<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      :custom-on-row-click="goNext"
      :model="model"
      :required-date-value="$parent.dateRange"
      :use-action="false"
      :use-default-action="false"
      entity-name="detail"
      icon="mdi-cards"
    />
    <v-dialog
      v-model="showDetailInfo"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center justify-center">
          <div class="text-h4 font-weight-bold">
            {{ $t('mealsDetail') }}
          </div>
          <v-spacer />
          <v-btn
            icon
            @click="showDetailInfo = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div>
          <template>
            <div>
              <div class="d-flex pr-4">
                <div> {{ detailInfo?.eventName }}</div>
                <v-spacer />
                {{ detailInfo?.createdAt | beautifulTime }}
              </div>
              <div
                v-if="detailInfo?.eventName === 'addDishToOrder'"
                class="mt-4"
              >
                <v-card
                  class="pa-2 ml-0 ma-1 text-body-1"
                  color="#eee"
                  elevation="0"
                >
                  <div>
                    <div class="d-flex">
                      <b>{{ Math.abs(currentParams.dish_info.count) }}&times; </b>
                      <span class="text-capitalize text-no-wrap text-truncate ml-2"> #{{
                        currentParams.dish_info.code
                      }} </span>
                      <v-spacer />
                      <template v-if="currentParams.dish_info.tempDiscountStr">
                        <span
                          class="text-decoration-line-through warning--text text--darken-1"
                          style="font-size: 10px"
                        >{{ currentParams.dish_info.price | priceDisplay }}</span>
                        <span class="text-no-wrap">
                          {{ parseFloat(currentParams.dish_info.price) + parseFloat(currentParams.dish_info.tempDiscountMod) | priceDisplay }}</span>
                      </template>
                      <span
                        v-else
                        class="text-no-wrap"
                      >{{ currentParams.dish_info.price | priceDisplay }}</span>
                    </div>
                    <div class="d-flex">
                      <span class="maxLine2">{{ currentParams.dish_info.name }}</span>
                      <v-spacer />
                      <div>{{ currentParams.servantName }}</div>
                    </div>
                  </div>
                  <template v-if="currentParams?.dish_info?.displayApply?.length > 0">
                    <div class="text-caption">
                      {{ currentParams.dish_info.modName }}
                    </div>
                  </template>
                </v-card>
              </div>
              <div
                v-else-if="detailInfo?.eventName === 'removeDishFromOrder'"
                class="mt-4"
              >
                <v-card
                  class="pa-2 ml-0 ma-1 text-body-1"
                  color="#eee"
                  elevation="0"
                >
                  <div class="d-flex align-center justify-center">
                    <div>
                      {{ detailInfo?.opBrief }}
                    </div>
                    <v-spacer />
                    <div class="d-flex flex-column">
                      <div>{{ currentParams?.reason }}</div>
                    </div>
                  </div>
                  <div class="d-flex align-center justify-center">
                    <div />
                    <v-spacer />
                    <div class="d-flex flex-column">
                      <div>{{ detailInfo.servantName }}</div>
                    </div>
                  </div>
                </v-card>
              </div>
              <div
                v-else
                class="mt-4"
              >
                <v-card
                  class="pa-2 ml-0 ma-1 text-body-1"
                  color="#eee"
                  elevation="0"
                >
                  <div class="d-flex">
                    <div>
                      {{ detailInfo?.opBrief }}
                    </div>
                    <v-spacer />
                  </div>
                </v-card>
              </div>
              <v-card
                class="pa-2 ml-0 ma-1 text-body-1 mt-4"
                color="#eee"
                elevation="0"
              >
                <div class="mt-2 text-body-1 font-weight-regular">
                  <json-viewer
                    :value="currentParams"
                    copyable
                  />
                </div>
              </v-card>
            </div>
          </template>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import OrderLog from '@/model/dataLayer/api/bills/OrderLog'
import JsonViewer from 'vue-json-viewer'

export default {
  name: 'BillTotal',
  components: {
    IkDataTable,
    JsonViewer
  },
  data () {
    return {
      detailInfo: null,
      showDetailInfo: false,
      model: OrderLog
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {

      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    currentParams () {
      const res = this.detailInfo ? JSON.parse(this.detailInfo?.opReq) : ''
      if (res.params) {
        return res.params
      } else {
        return res
      }
    }
  },
  methods: {
    goNext (info) {
      this.detailInfo = info
      this.showDetailInfo = true
    }
  }
}
</script>

<style scoped>

</style>
